import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import IconChevronLeft from '~~elements/static/IconChevronLeft.svg';
import DefaultAvatar from '~~elements/static/DefaultAvatar.jpg';
import { useQuery } from '~~utils/CommonUtils';
import UTRMultilingual from './Multilingual';
import { StyledDiv } from '../Settings/Styles';
import { useRootState } from '../../useRoot';
import ListTeamsInRegistries from './components/ListTeamsInRegistries';
import TeamInRegistry from './TeamInRegistry/TeamInRegistry';
import { useRegistryDispatch, useRegistryState } from './useUserTournamentRegistry';

const UserTournamentRegistry = ({
  list: apiResponseList,
  registryList,
  teamInRegistry: apiTeamInRegistry,
  registry,
}) => {
  const query = useQuery();
  const { loginInfo } = useRootState();

  const { list, team } = useRegistryState();
  const dispatch = useRegistryDispatch();

  useEffect(() => {
    dispatch({ type: 'SET_LIST', payload: apiResponseList });
  }, [apiResponseList, dispatch]);

  useEffect(() => {
    dispatch({ type: 'SET_TEAM', payload: apiTeamInRegistry });
  }, [apiTeamInRegistry, dispatch]);

  const handleTeamInRegistrySelect = (teamInRegistry) => () => {
    query.set({ registry: teamInRegistry.registry_uniqid, team: teamInRegistry.uniqid });
  };

  if (team && registry) {
    return <TeamInRegistry teamInRegistry={team} registry={registry} />;
  }

  return (
    <StyledDiv>
      <div className="greet">
        <img className="greet--pic" src={loginInfo.avatarUrl ? loginInfo.avatarUrl : DefaultAvatar} alt="" />
        <div className="greet--name">{UTRMultilingual(`CUSTOM.REGISTRY_PANEL`)}</div>
      </div>
      <div className="panel">
        <div className="section-list">
          <div className="section-list--title" />
          <Link
            className="section-list--item"
            to={() => ({
              pathname: `/settings/user_profile`,
            })}
          >
            <img style={{ width: '1rem', height: '1rem' }} src={IconChevronLeft} alt="back" />
            {UTRMultilingual(`ACCOUNT_MANAGEMENT.WORDING`)}
          </Link>
        </div>
        <div className="section lg">
          <ListTeamsInRegistries list={list} handleTeamInRegistry={handleTeamInRegistrySelect} />
        </div>
      </div>
    </StyledDiv>
  );
};

export default UserTournamentRegistry;
